<h3>{{'help.formStep.step2'|translate}}</h3>
<mat-accordion [multi]="true" displayMode="flat" class="accordion-container">
  <mat-expansion-panel *ngFor="let release of (releaseNotesHelps$ | async)" [togglePosition]="'after'">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="content">
          <img [src]="'assets/svg-icons/release.svg'" alt="{{ release?.attributes?.title }}" class="icon" />
          <div class="video-title release-title">
            <span>{{ release?.attributes?.title }}</span><br />
            <span class="date">{{ release?.attributes?.date }}</span>
          </div>
          <div class="link">    </div>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <hr />
      <div class="videoContent release" *ngIf="release.attributes.videoId">
        <h4>{{'help.releaseHelp.videoContentTitel'|translate}}</h4>
        <iframe [src]="getSafeVideoUrl(release?.attributes?.videoId)" allow="autoplay; fullscreen; picture-in-picture" title="{{ release?.attributes?.title }}"></iframe>
      </div>
      <hr />
      <div class="releaseContent">
        <h4>{{'help.releaseHelp.releaseContentTitel'|translate}}</h4>
        <div *ngIf="release.attributes.features || release.attributes.addons || release.attributes.bugs">
          <ul>
            <li *ngIf="release.attributes.features" class="mainList">{{'help.releaseHelp.releaseContentListFeatures'|translate}}
              <ul *ngFor="let feature of splitReleaseNotesStructured(release?.attributes?.features)">
                <li>
                  {{ feature.main }}
                  <ul *ngIf="feature.subItems.length">
                    <li *ngFor="let sub of feature.subItems">{{ sub }}</li>
                  </ul>
                </li>
              </ul>
            </li>
            <li *ngIf="release.attributes.addons" class="mainList">{{ 'help.releaseHelp.releaseContentListAddons' | translate }}
              <ul>
                <li *ngFor="let addon of splitReleaseNotesStructured(release?.attributes?.addons)">
                  {{ addon.main }}
                </li>
              </ul>
            </li>

            <li *ngIf="release.attributes.bugs" class="mainList">{{ 'help.releaseHelp.releaseContentListBugs' | translate }}
              <ul>
                <li *ngFor="let bug of splitReleaseNotesStructured(release?.attributes?.bugs)">
                  {{ bug.main }}
                </li>
              </ul>
            </li>
          </ul>

        </div>
      </div>
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>
